<template>
    <div class="list">
        <NavBar></NavBar>
        <div class="title_top">
            <div class="title_son" style="text-align:center;padding:20px 0">
                <van-col span='24' style="margin-top:5px;text-align:center;font-weight:bold;margin-bottom:10px;color:#fff;line-height:100px">绑定房屋--新增</van-col>
            </div>
        </div>
        <van-form @submit="onSubmit" style="margin-top:10px">
            <div class="AddressList">
                <!-- 小区 -->
                <van-field v-model="residential" is-link readonly label="小区" placeholder="请选择小区" @click="residentialOpen"  :rules="[{ required: true }]"/>
                <van-popup v-model:show="residentialshow" position="bottom" :style="{ height: '50%' }">
                    <van-search v-on:input ="Searchresidential" placeholder="请输入小区名搜索" v-model="residentialSearch" :clearable='false'/>
                    <van-picker @cancel="residentcancel" @confirm="onConfirm" show-toolbar title="选择小区" value-key='rename' :columns="residentcolumnscopy" />
                </van-popup>
                <!-- 楼栋 -->
                <van-field v-model="building" is-link readonly label="楼栋" placeholder="请选择楼栋" @click="buildingOpen"  :rules="[{ required: true }]"/>
                <van-popup v-model:show="buildingshow" position="bottom" :style="{ height: '50%' }">
                    <van-search v-on:input ="Searchbuilding" placeholder="请输入楼栋名搜索" v-model="buildingSearch" :clearable='false'/>
                    <van-picker @cancel="buildingcancel" @confirm="onConfirm1" show-toolbar title="选择楼栋" value-key='bldname' :columns="buildingcolumnscopy" />
                </van-popup>
                <!-- 单元 -->
                <van-field v-model="unit" is-link readonly label="单元" placeholder="请选择单元" @click="unitOpen"  :rules="[{ required: true }]"/>
                <van-popup v-model:show="unitshow" position="bottom" :style="{ height: '50%' }">
                    <van-picker @cancel="unitcancel" @confirm="onConfirm2" show-toolbar title="选择单元" value-key='cellname' :columns="unitcolumns" />
                </van-popup>
                <!-- 房间 -->
                <van-field v-model="room" is-link readonly label="房间" placeholder="请选择房间" @click="roomshowClick"  :rules="[{ required: true }]"/>
                <van-popup v-model:show="roomshow" position="bottom" >
                    <van-search v-on:input ="SearchRoom" placeholder="请输入房间号搜索" v-model="positionSearch" :clearable='false'/>
                    <van-picker @cancel="roomcancel" @confirm="onConfirm3" show-toolbar title="选择房间" value-key='housename' :columns="roomcolumnscopy" />
                </van-popup>
                <!-- 业主姓名 -->
                <van-field v-model="ownername" label="姓名" placeholder="请输入业主姓名" :rules="[{ required: true }]"/>
                <!-- 业主手机号 -->
                <van-field v-model="phone" label="手机" placeholder="请输入手机号" :rules="[{ validator}]" />
            </div>
            <div style="margin: 16px;position:fixed;bottom:0;left:0;right:0" v-show="hidshow">
                <van-button block type="primary" native-type="submit">保 存</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import VueCookie from 'vue-cookie'
export default {
    data(){
        return{
            screenHeight: document.documentElement.clientHeight,//一个是实施的高度一个是手机整体的高度 底下判断监听
            originHeight: document.documentElement.clientHeight,
            hidshow:true,
            //
            openId:'',
            headImgUrl:'',
            //小区
            residential:'',
            residentialshow:false,
            residentcolumns:[],
            residentcolumnscopy:[],
            reguid:'',
            //楼栋
            building:'',
            buildingshow:false,
            buildingcolumns:[],
            buildingcolumnscopy:[],
            bldguid:'',
            //单元
            unit:'',
            unitshow:false,
            unitcolumns:[],
            cellguid:'',
            //房间
            room:'',
            roomshow:false,
            roomcolumns:[],
            roomcolumnscopy:[],
            houseguid:'',
            //搜索
            positionSearch:'',
            residentialSearch:'',
            buildingSearch:'',
            // 姓名
            ownername:'',
            phone:'',
        }
    },
    mounted(){
        let self = this;
        window.onresize = function() {
          return (function(){
              self.screenHeight = document.documentElement.clientHeight;
          })()
        }
    },
    watch:{
        screenHeight (val) {
          if(this.originHeight > val + 100) {        //加100为了兼容华为的返回键
              this.hidshow = false;
          }else if(this.originHeight == val ){
              this.hidshow = true
          }else{
              this.hidshow = true;
          }
      }
    },
    methods:{
        residentialOpen(){
            this.residentialshow = true
            this.residentialSearch=''
            this.Searchresidential()
        },
        buildingOpen(){
            if(!this.residential){
                this.buildingshow = false
                this.$toast('请先选择小区')
            }else{
                this.buildingshow = true
                this.buildingSearch=''
                this.Searchbuilding()
            }
        },
        unitOpen(){
            if(!this.building){
                this.unitshow=false
                this.$toast('请先选择楼栋')
            }else{
                this.unitshow = true
            }
        },
        validator(val) {
            return /^1\d{10}$/.test(val);
        },
        // 取消
        residentcancel(){
            this.residentialshow=false
        },
        buildingcancel(){
            this.buildingshow = false
        },
        unitcancel(){
            this.unitshow = false
        },
        roomcancel(){
            this.roomshow = false
        },
        // 获取小区
        getRegion(){
            this.$postQuery('/RegionInfo/getList').then((response) => {
                if(response.code==200){
                    this.residentcolumns=response.data
                }
            })
        },
        //获取楼栋
        getBuilding(){
            let data={
                reguid:this.reguid
            }
            this.$postQuery('/BldInfo/getListByReGuid',data).then((response) => {
                if(response.code==200){
                    this.buildingcolumns=response.data
                }
            })
        },
        //获取单元
        getUnite(){
            let data={
                bldguid:this.bldguid
            }
            this.$postQuery('/CellInfo/getListByBldGuid',data).then((response) => {
                if(response.code==200){
                    this.unitcolumns=response.data
                }
            })
        },
        // 获取房间
        getRoom(){
            let data={
                cellguid:this.cellguid
            }
            this.$postQuery('/HouseInfo/getListByCellGuid',data).then((response) => {
                if(response.code==200){
                    this.roomcolumns=response.data
                }
            })
        },
        onConfirm(value){
            this.residential = value.rename
            this.reguid = value.reguid
            this.residentialshow = false
            // 
            this.building=''
            this.unit=''
            this.room=''
            // 
            this.getBuilding()
        },
        onConfirm1(value){
            this.building = value.bldname
            this.bldguid = value.bldguid
            this.buildingshow = false
            // 
            this.unit=''
            this.room=''
            // 
            this.getUnite()
        },
        onConfirm2(value){
            this.unit = value.cellname
            this.cellguid = value.cellguid
            this.unitshow = false
            // 
            this.room=''
            // 
            this.getRoom()
        },
        //搜索楼栋
        Searchbuilding(){
            // 
            let data=[]
            this.buildingcolumns.forEach((item)=>{
                if(this.buildingSearch){
                    if(item.bldname.indexOf(this.buildingSearch)>-1){
                        data.push(item)
                    } 
                }else{
                    data.push(item)
                }
                this.buildingcolumnscopy = data
            })
        },
        //搜索小区
        Searchresidential(){
            let data=[]
            this.residentcolumns.forEach((item)=>{
                if(this.residentialSearch){
                    if(item.rename.indexOf(this.residentialSearch)>-1){
                        data.push(item)
                    }
                }else{
                    data.push(item)
                }
                this.residentcolumnscopy = data
            })
        },
        // 搜索房间
        SearchRoom(){
            let data=[]
            this.roomcolumns.forEach((item)=>{
                if(this.positionSearch){
                    if(item.housename.indexOf(this.positionSearch) > -1){
                        data.push(item)
                    }
                }else{
                    data.push(item)
                }
                this.roomcolumnscopy = data
            })
        },
        roomshowClick(){
            if(!this.unit){
                this.roomshow = false
                this.$toast('请先选择单元')
            }else{
                this.positionSearch=''
                this.roomshow = true
                this.SearchRoom()
            }
        },
        // 
        onConfirm3(value){
            this.room = value.housename
            this.houseguid = value.houseguid
            this.roomshow = false
        },
        onSubmit(){
            let data={
                houseguid:this.houseguid,
                ownername:this.ownername,
                phone:this.phone,
                openid:this.openId
            }
            console.log(data)
            this.$postQuery('/OwnerInfo/bindHouseAndWeChat',data).then((response) => {
                console.log(response)
                if(response.code==200){
                    this.$toast('操作成功')
                    this.$router.push('/PersonalCenter')
                }else{
                    this.$toast(response.data)
                }
            })
        }
    },
    created(){
        this.getRegion()
        this.openId = VueCookie.get('openId')
    }
}
</script>

<style scoped>
.list {
    margin-top: 46px;
    /* padding: 25px 15px;
    background: linear-gradient(to right,#9ec6e9,#72bee3); */
}
.AddressList{
    /* background-color: gray; */
    padding: 0 15px;
    /* border-radius: 10px; */
    /* overflow: hidden; */
}
    .title_top{
        padding:7px;
    }
    .title_son{
        background-image: url('../../assets/Image/house-banner.png');
        background-repeat:no-repeat;
        background-position:center;
        background-size: 100% auto;
        border-radius: 4px;
    }
</style>